module.exports = __webpack_public_path__ + "img/dialog-bg.826e2c63.png";